var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-progress-bar-container"},[_c('div',{staticClass:"linear-progress-bar-outer"},[_c('div',{staticClass:"linear-progress-bar-inner",style:({width:((_vm.currentStep/_vm.noOfSteps)*100)+'%'})})]),_c('div',{staticClass:"linear-progress-bar-caption"},[_vm._v(" "+_vm._s(_vm.currentStep)+" of "+_vm._s(_vm.noOfSteps)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }